module.exports = new __parcel__URL__("trucker.86c2adc8.webp").toString();